import React from "react";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemSearchResult from "../../../models/ItemSearchResult";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import ItemSearchMiniView from "../../Search/ItemMini";

interface ProjectItemRevisionCreateModel {
    projectId: number
    itemRevisionId: number
}

const AddProjectItemPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId, projectTypeId }) => {
    const { handleResult, handleException } = useNotifications();

    function handleItemclicked(itemRevision: ItemSearchResult) {
        const projectItemRevision: ProjectItemRevisionCreateModel = {
            projectId,
            itemRevisionId: itemRevision.itemRevisionId
        }

        DataService
            .create<ProjectItemRevisionCreateModel>(`api/v1/ProjectItemRevisions`, projectItemRevision)
            .then(response => {
                handleResult(response, true);
                if (response.isSuccesful === true) {
                    if (onHide)
                        onHide();
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'xxl'} title={'Add item'}>
            <Popup.Body>
                <ItemSearchMiniView handleItemClicked={handleItemclicked} projectId={projectId} projectTypeId={projectTypeId} forBom={false} />
            </Popup.Body>
        </Popup>
    );
}
export default AddProjectItemPopup;